import React from 'react';
import { getTranslation } from '../../assets/creator/translations';
import { formatString } from '../../utils/string/string';
import './GenerateTemplateModal.css';

const GenerateTemplateModal = (props) => {
    if (!props.show) {
        return null;
    }

    return (
        <div className="generate-template-modal">
            <div className="generate-template-modal__wrapper generate">
                <p className="generate-template-modal__title">
                    {formatString(getTranslation("Msg_TemplateGeneration"))}
                </p>
                <p className="generate-template-modal__text">
                    {formatString(getTranslation("Msg_TemplateGenerationInstruction"))}
                </p>
                <button onClick={props.onClose} className="generate-template-modal__accept">{getTranslation("close")}</button>
            </div>
        </div>
    );
}

export default GenerateTemplateModal;
